<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="dialogVisible" destroy-on-close title="绑定邮箱" width="600px">
		<div>
			<el-form ref="formRef" :model="form" :rules="rules" label-position="top" label-width="120px">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="邮箱：" prop="newEmail">
							<el-input v-model.trim="form.newEmail" placeholder="请输入邮箱" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">关闭</el-button>
				<el-button size="small" type="primary" @click="handleConfirm"> 保存 </el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import TMessage from '@/utils/TMessage';
import { mapGetters } from 'vuex';
import { postMemberUpdatePhoneMail } from '@/api/user/user.js';

export default {
	name: 'DialogEditMail',
	data() {
		//校验邮箱
		const validateMail = (rule, value, callback) => {
			let reg = /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/;
			if (!value) {
				return callback(new Error('邮箱不能为空'));
			}
			if (value) {
				if (!reg.test(value)) {
					return callback(new Error('邮箱格式不正确'));
				}
			}
			callback();
		};
		return {
			dialogVisible: false,
			form: {
				oldEmail: '',
				newEmail: '',
				itype: 1
			},
			rules: {
				newEmail: [{ required: true, validator: validateMail, trigger: 'blur' }]
			}
		};
	},
	computed: {
		...mapGetters('User', ['uinfo'])
	},
	watch: {
		dialogVisible(val) {
			if (!val) {
				this.resetForm();
			}else {
				this.form.newEmail = this.uinfo.consumerEmail;
			}
		}
	},
	methods: {
		handleClose() {
			this.resetForm();
			this.$emit('cancel');
		},

		resetForm() {
			this.$refs['formRef'].resetFields();
		},

		handleConfirm() {
			this.$refs['formRef'].validate(valid => {
				if (valid) {
					this.updatePhoneMail();
				}
			});
		},

		//更新客户信息
		updatePhoneMail() {
			this.form.oldEmail = this.uinfo.consumerEmail;
			postMemberUpdatePhoneMail(this.form).then(res => {
				let { code, data, msg } = res;
				if (code == 200) {
					TMessage.success('邮箱绑定成功');
					this.$emit('confirmInfo');
				} else if (msg) {
					TMessage.warning(msg);
				} else {
					TMessage.warning('邮箱更新失败');
				}
			});
		}
	}
};
</script>

<style lang="less" scoped>
// 弹出框重置样式
/deep/ .el-dialog__header {
	border-bottom: 1px dashed #e2e8f0;
	margin-right: 0;
	background: #f8fafc;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
</style>
